import Vue, { PluginObject } from 'vue'

const ensureLoadingState = (instance: Vue) => {
  if (typeof (instance as any).isLoading === 'undefined') {
    Vue.set(instance, 'isLoading', false)
  }
}

const loadingPlugin: PluginObject<void> = {
  install(VueApp) {
    VueApp.mixin({
      data() {
        if (this === this.$root) {
          return { isLoading: false }
        }
        return {}
      },
      methods: {
        startLoading(this: Vue) {
          const root = (this.$root || this) as Vue
          ensureLoadingState(root)
          ;(root as any).isLoading = true
        },
        stopLoading(this: Vue) {
          const root = (this.$root || this) as Vue
          ensureLoadingState(root)
          ;(root as any).isLoading = false
        }
      }
    })
  }
}

export default loadingPlugin
